/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.academics.grades'},
});

const GradesItem = () => (
  <RouteLinkItem
    route="midas/settings/academics/grades"
    title={messages.title}
  />
);

export default GradesItem;
